import { Helmet } from "react-helmet";
import "../styles/PermanentJewelry.css";

export default function PermanentJewelry() {
  return (
    <main className="permanent-jewelry-page">
      <Helmet>
        <title>Permanent Jewelry in Rochester NY | Lash With Brittany</title>
        <meta
          name="description"
          content="Permanent jewelry in Rochester NY. Custom welded bracelets, anklets, and necklaces with a seamless, clasp free finish."
        />
        <link
          rel="canonical"
          href="https://lashwithbrittany.com/permanent-jewelry"
        />
      </Helmet>

      {/* ================= HERO ================= */}
      <section className="jewelry-hero" aria-label="Permanent jewelry hero">
        <div className="jewelry-container jewelry-hero-inner">
          <div className="jewelry-hero-text">
            <p className="jewelry-eyebrow">Rochester, New York</p>

            <h1>Permanent Jewelry</h1>

            <p className="jewelry-lead">
              A seamless, clasp free piece of jewelry custom fit and welded just
              for you.
            </p>

            <div className="jewelry-hero-actions">
              <a href="/book" className="jewelry-btn jewelry-btn-primary">
                Book Now
              </a>

              <a href="#party" className="jewelry-btn jewelry-btn-secondary">
                Host a Party
              </a>
            </div>

            <ul className="jewelry-highlights" aria-label="Permanent jewelry highlights">
              <li className="jewelry-highlight">
                <span className="jewelry-highlight-title">Custom fit</span>
                <span className="jewelry-highlight-sub">Sized to you, every time</span>
              </li>

              <li className="jewelry-highlight">
                <span className="jewelry-highlight-title">Welded in minutes</span>
                <span className="jewelry-highlight-sub">Quick, simple, and safe</span>
              </li>

              <li className="jewelry-highlight">
                <span className="jewelry-highlight-title">Made for real life</span>
                <span className="jewelry-highlight-sub">Everyday wear approved</span>
              </li>
            </ul>
          </div>

          <div className="jewelry-hero-media">
            <div className="jewelry-hero-image-frame">
                <div className="jewelry-hero-image-white">
              <img
                src="/images/jewelry.png"
                alt="Close up of wrist with permanent bracelet in dreamy pastel tones"
                loading="eager"
                width="520"
                height="520"
              />
            </div>
          </div>
          </div>
        </div>
      </section>

      {/* ================= WHAT IT IS ================= */}
      <section className="jewelry-section" aria-label="What is permanent jewelry">
        <div className="jewelry-container">
          <div className="jewelry-card">
            <h2 className="jewelry-card-title">What Is Permanent Jewelry</h2>
            <p className="jewelry-body">
              Seamless is all about connection. I custom fit delicate chains and
              weld them with a tiny flash so you never fuss with clasps again.
              These pieces move with you and shine through everyday moments.
            </p>
          </div>
        </div>
      </section>

      {/* ================= HOW IT WORKS ================= */}
      <section className="jewelry-section" aria-label="How permanent jewelry works">
        <div className="jewelry-container">
          <div className="jewelry-card">
            <h2 className="jewelry-card-title">How It Works</h2>

            <ol className="jewelry-steps">
              <li>
                <span className="jewelry-step-strong">Pick your chain:</span>{" "}
                14k gold fill, sterling silver, or stainless steel.
              </li>
              <li>
                <span className="jewelry-step-strong">Add a charm</span> if it
                speaks to you.
              </li>
              <li>
                <span className="jewelry-step-strong">I’ll size it</span> so it
                sits just right.
              </li>
              <li>
                <span className="jewelry-step-strong">A quick little zap</span>{" "}
                seals it in place.
              </li>
            </ol>
          </div>
        </div>
      </section>

      {/* ================= IS IT FOREVER ================= */}
      <section className="jewelry-section" aria-label="Is it really forever">
        <div className="jewelry-container">
          <div className="jewelry-card">
            <h2 className="jewelry-card-title">Is It Really Forever</h2>
            <p className="jewelry-body">
              It stays as long as you want. If it needs to come off, snip it and
              I can reweld it at your next appointment.
            </p>
          </div>
        </div>
      </section>

      {/* ================= WHO IT’S FOR ================= */}
      <section className="jewelry-section" aria-label="Who is seamless for">
        <div className="jewelry-container">
          <div className="jewelry-card">
            <h2 className="jewelry-card-title">Who Is Seamless For</h2>

            <ul className="jewelry-bullets">
              <li>Besties sealing a forever vibe</li>
              <li>Couples celebrating a moment</li>
              <li>Moms and daughters making memories</li>
              <li>Bridal parties and bachelorette groups</li>
              <li>Solo self care or anyone who loves a little shine</li>
            </ul>
          </div>
        </div>
      </section>

      {/* ================= THINGS TO KNOW ================= */}
      <section className="jewelry-section" aria-label="Things to know before you zap">
        <div className="jewelry-container">
          <div className="jewelry-card">
            <h2 className="jewelry-card-title">Things to Know Before You Zap</h2>

            <ul className="jewelry-bullets">
              <li>Painless and safe. The tool never touches your skin.</li>
              <li>Waterproof and tarnish resistant.</li>
              <li>Sizing matters and I’ll guide you every step.</li>
            </ul>
          </div>
        </div>
      </section>

      {/* ================= PARTY HOSTING ================= */}
      <section className="jewelry-section" id="party" aria-label="Host a seamless party">
        <div className="jewelry-container">
          <div className="jewelry-card jewelry-card-accent">
            <h2 className="jewelry-card-title">Host a Seamless Party</h2>

            <p className="jewelry-body">
              Turn good times into lasting sparkle. I bring chains, charms, and
              tools right to your space.
            </p>

            <ul className="jewelry-bullets">
              <li>Minimum of five guests</li>
              <li>Available around Rochester, NY</li>
              <li>DM me or fill out the party request form to start</li>
            </ul>

            <div className="jewelry-inline-cta">
              <a href="/contact-me" className="jewelry-btn jewelry-btn-secondary">
                Ask About Parties
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ================= FINAL CTA ================= */}
      <section className="jewelry-final-cta" aria-label="Book permanent jewelry">
        <div className="jewelry-container">
          <div className="jewelry-final-cta-inner">
            <h2>Let’s Make It Seamless</h2>
            <p>
              Book online or reach out to plan a permanent jewelry moment that
              feels just right.
            </p>

            <div className="jewelry-final-actions">
              <a href="/book" className="jewelry-btn jewelry-btn-primary">
                Book Now
              </a>
              <a href="/contact-me" className="jewelry-btn jewelry-btn-secondary">
                Contact
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
